import React from 'react'
import {Field} from 'redux-form'
import styles from 'jbc-front/components/SearchForm.scss'
import commentStyles from 'components/Comments.scss'

const COMMENT_COLORS = ['blue', 'yellow', 'pink', 'green', 'purple', 'orange']

const CommentColorsCheckbox = ({input: inputProps, colors}) => {
  const values = inputProps.value || []
  return (
    <div>
      {colors.map((color) => (
        <label key={color} className={commentStyles.commentColorLabel}>
          <input
            type="checkbox"
            className="m-checkbox-input"
            checked={values.includes(color)}
            onChange={() => {
              const newValues = values.includes(color) ? values.filter((v) => v !== color) : [...values, color]
              inputProps.onChange(newValues)
              inputProps.onBlur(newValues)
            }}
          />
          <span className="m-checkbox-parts">
            {color === 'empty' ? 'メモ無し' : <span className={commentStyles[`comment_${color}`]}>●</span>}
          </span>
        </label>
      ))}
    </div>
  )
}

const CommentColors = () => {
  const colors = [...COMMENT_COLORS, 'empty']
  return (
    <div className={styles.detailsRow}>
      <div className={styles.detailsHeader}>メモカラー</div>
      <div className={styles.detailsBody}>
        <Field name="comment_colors" component={CommentColorsCheckbox} colors={colors} />
      </div>
    </div>
  )
}

export default CommentColors
